<template>
  <ToastMessage />
  <keep-alive>
    <side-nav v-if="$route.meta.auth == false"></side-nav>
  </keep-alive>
  <div
    :class="{
      app_container: $route.meta.auth == false,
      app_container_locked: sideMenuLock,
      app_container_unlocked: !sideMenuLock,
    }"
  >
    <notification-banner
      v-if="$route.meta.auth == false && companyType == 'business'"
    ></notification-banner>
    <div :class="showBanner ? 'banner_top' : null">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
  <DynamicDialog />
</template>

<script>
import { computed } from "vue";
import { mapGetters } from "vuex";
import SideNav from "./components/layout/TheSideNav.vue";
import NotificationBanner from "./components/layout/TheNotificationBanner.vue";
import { socket } from "./util/socketioService.js";
import { setBrandTheme } from "./util/themeService";
import SocketIoService from "./mixins/ioSocketService.js";

export default {
  components: {
    SideNav,
    NotificationBanner,
  },
  provide() {
    return {
      buttonRounded: computed(() => this.theme?.buttonStyle === "pill"),
    };
  },
  computed: {
    ...mapGetters("userData", [
      "sideMenuLock",
      "showBanner",
      "userId",
      "companyId",
      "companyType",
      "theme",
    ]),
  },
  created() {
    socket.connect();
    socket.emit("join", [this.userId, this.companyId]);

    if (this.theme.themeEnabled) {
      setBrandTheme(this.theme.styles);
    }
  },
  beforeUnmount() {
    socket.disconnect();
  },
  mixins: [SocketIoService],
};
</script>

<style scoped>
.app_container {
  position: relative;
}

.banner_top {
  top: 65px;
  position: relative;
}

.app_container_unlocked {
  left: 70px;
  width: calc(100% - 70px);
}
.app_container_locked {
  left: 240px;
  width: calc(100% - 240px);
}

@media only screen and (max-width: 500px) {
  .app_container_unlocked {
    left: 0px;
    width: 100%;
  }
  .app_container_locked {
    left: 0px;
    width: 100%;
  }

  .banner_top {
    top: 0px;
  }
}
</style>
